export default __webpack_public_path__ + "static/academy-46e24042737ff785606e1a527bc87e77.png";